import React from 'react';

function About() {
  return(
      <>
        <h1>About</h1>
        <p>Information System graduate with understanding of various programming languages and building databases. 
        Experienced in Manual Testing for Software Quality Assurance (SQA). Knowledgeable in Open-Source Tools and 
        Testing Methodologies (i.e. Agile, Waterfall). Familiar with Object-Oriented Programming in .Net and Java. 
        Seeking to grow knowledge and build expertise on testing strategies around manual, automation and 
        performance testing. </p>
      </>
  )  
}

export default About;